import { Component, inject } from '@angular/core'
import { RouterModule } from '@angular/router'
import { MatRippleModule } from '@angular/material/core'

import { CoreParkLogo } from '@components/corepark-logo'
import { OperatorDataState } from '@states/operator-data'

import { OptionIcon } from '../option-icon'

@Component({
	selector: 'app-navigation',
	templateUrl: './navigation.component.html',
	styleUrls: ['./navigation.component.scss'],
	imports: [RouterModule, MatRippleModule, CoreParkLogo, OptionIcon],
})
export class AppNavigationComponent {
    readonly #operatorDataState = inject(OperatorDataState)
    
    readonly isCurbstand = this.#operatorDataState.isCurbstand
    
	readonly navigation = [
		{
			label: 'Validate',
			url: '/',
			icon: 'validations',
		},
		{
			label: 'Request Car',
			url: '/request-car',
			icon: 'request-car',
		},
		{
			label: 'Overnight Report',
			url: '/overnight-report',
			icon: 'overnight-report',
		},
		{
			label: 'Valet Service Monitoring',
			url: '/valet-service-monitoring',
			icon: 'valet-service-monitoring',
		},
	]
}
